import { Outlet, useLoaderData, useOutletContext } from 'react-router';
import Sidebar from './Sidebar/Sidebar';
import { Box } from '@mui/material';
import { authedApiFetch } from '../utils/Api';
import AIMeDrawerControl from '../features/AIMe/AIMeDrawerControl';

export const tenantLoader = async ({ params }) => {
	// Get tenant ID from URI
	const { tenantId } = params;

	return await authedApiFetch({
		endpoint: `/tenants/${tenantId}`,
		method: 'GET',
	});
};

const Tenant = () => {
	const tenant = useLoaderData();
	const outletData = useOutletContext();

	const showAIMe = process.env.REACT_APP_SHOW_AIME === 'true';

	return (
		<Box sx={{ display: 'flex', width: '100%', height: '100%' }}>
			<Sidebar tenant={tenant} user={outletData.user} />
			<Box
				component='main'
				sx={{ flexGrow: 1, pt: 0, pb: 3, pr: 1.5, pl: 1.5, overflow: 'auto' }}
			>
				<Outlet context={{ tenant, ...outletData }} />
			</Box>
			{outletData.user && showAIMe && <AIMeDrawerControl tenantId={tenant.id} />}
		</Box>
	);
};

export default Tenant;
